import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import { SelectionControlGroup, Checkbox } from "react-md";
import PNXLabel from "./PNXLabel";


interface ReadOnlyProps {
  controlProps: controls.ListFormControl;
}
interface Props extends ReadOnlyProps {
  updateValue: (newValue: string) => void;
  onControlBlur: () => void;
};

const PhoenixSelect = ({
  controlProps,
  updateValue,
  onControlBlur,
} : Props) => {

  // we have only ever used "full" appearance i.e. checkboxes
  const id = `select-${controlProps.id}`;

  // if its just a single dropdown, we need to render it differently because the SelectionControlGroup doesnt allow me to flex it :(
  if (controlProps.items?.length === 1 && controlProps.items[0].label === "") {
    return (
      <Checkbox
        className="pnx-select-single-option"
        label={<PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>}
        id={id}
        name={id}
        labelBefore
        onChange={checked => updateValue(checked ? controlProps.items[0].value : "")}
        onBlur={() => onControlBlur()}
        checked={controlProps.value == controlProps.items[0].value}
      />
    );
  } else {
    return <div>
      <SelectionControlGroup
        id={id}
        name={id}
        type="checkbox"
        label={<PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>}
        value={controlProps.value ?? ""}
        controls={controlProps.items}
        onChange={(value) => updateValue(value)}
        onBlur={() => onControlBlur()}
      />
    </div>;
  }
};

export const willPhoenixSelectReadOnlyRender = (controlProps: controls.ListFormControl) => {
  if (!controlProps.value || !controlProps?.value?.split(",")?.length) return false;
  return true;
};

export const PhoenixSelectReadOnly = ({
  controlProps,
} : ReadOnlyProps) => {

  if (!controlProps.value) return null;

  const selectedValues = controlProps.value.split(",");
  const selectedLabels = [];

  for (const value of selectedValues) {
    const option = controlProps.items.filter(item => item.value === value);
    if (option.length) {
      let label = option[0].label;
      if (!label && value === "1") // sweet
        label = "Yes";

      selectedLabels.push(label);
    }
    else {
      selectedLabels.push(value);
    }
  }

  if (!selectedLabels.length) return null;

  return (
    <div className={selectedLabels.length == 1 && "pnx-select-single-option"}>
      <PNXLabel>{controlProps.label}</PNXLabel>
      <div>
        {selectedLabels.map(label => <div>{label}</div>)}
      </div>
    </div>
  );
};

export default PhoenixSelect;